import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { fr, chf } from "../content/fr";
import { paymentStatus, upsellOrder, declineUpsell } from "../lib/api";
import { track } from "../lib/tracking";
import Seo from "../components/Seo";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Upsell() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const orderId = params.get("order");
  const [status, setStatus] = useState("pending");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!orderId) { navigate("/"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const r = await paymentStatus(sessionId);
        if (r.statut === "paye") { setStatus("paye"); track("Purchase", { value: r.montant }); return; }
      } catch {}
      tries += 1;
      if (tries < 15) setTimeout(poll, 2000); else setStatus("timeout");
    };
    if (sessionId) poll(); else setStatus("timeout");
  }, [sessionId, orderId, navigate]);

  const goMerci = () => navigate(`/merci/pilote?order=${orderId}`);

  const accept = async () => {
    setBusy(true); setError(null);
    try { await upsellOrder(orderId); track("Purchase", { value: 297, type: "upsell" }); goMerci(); }
    catch { setError(fr.merci.upsellError); setBusy(false); }
  };
  const decline = async () => {
    setBusy(true);
    try { await declineUpsell(orderId); } catch {}
    goMerci();
  };

  return (
    <div>
      <Seo routeKey="/pilote" path="/upsell/programme-lancement" title="Programme de Lancement | VIRALYA" />
      <Header />
      <main className="page">
        <div className="container page-narrow">
          <div className="steps-bar"><div className="step active" /><div className="step active" /><div className="step active" /></div>
          {status !== "paye" ? (
            <div className="glass card center" data-testid="upsell-pending">
              <p className="muted">{status === "timeout" ? "Nous confirmons votre paiement. Vous pouvez continuer." : fr.merci.pending}</p>
              {status === "timeout" && <button className="btn btn--ghost" style={{ marginTop: "1rem" }} onClick={goMerci} data-testid="upsell-continue">Continuer</button>}
            </div>
          ) : (
            <div data-testid="upsell-offer">
              <span className="eyebrow"><span className="sq" />Offre unique</span>
              <h1 className="h2" style={{ marginBottom: "0.75rem" }}>{fr.merci.upsellTitle}</h1>
              <p className="lead" style={{ marginBottom: "1.5rem" }}>{fr.merci.upsellDesc}</p>
              <div className="glass card">
                <div className="summary-row total"><span>Programme de Lancement 14 jours</span><span className="tnum">{chf(297)}</span></div>
                <button className="btn btn--primary btn--block" style={{ marginTop: "1.4rem" }} onClick={accept} disabled={busy} data-testid="upsell-accept">
                  {busy ? "Traitement…" : `${fr.merci.upsellCta} · ${chf(297)}`} <ArrowRight size={16} />
                </button>
                {error && <p className="form-status err" data-testid="upsell-error">{error}</p>}
                <button onClick={decline} disabled={busy} className="muted" style={{ display: "block", margin: "1rem auto 0", background: "none", fontSize: "0.88rem", minHeight: 44 }} data-testid="upsell-decline">
                  Non merci, continuer
                </button>
                <p className="muted" style={{ fontSize: "0.8rem", marginTop: "0.5rem", textAlign: "center" }}>Ajout en un clic sur votre carte enregistrée. <Check size={12} style={{ verticalAlign: "middle" }} /> Nous ne l'offrons pas : ce qui est offert n'est pas exécuté.</p>
              </div>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
